import React, {useContext, useEffect, useMemo, useState} from 'react'
import localization from "../../../../../assets/localization/localization";
import Layout from "../../../../../components/sales/layout/layout";
import DivLayout from "../../../../../components/sales/divLayout/divLayout";
import {Button} from "react-bootstrap";
import {toast} from "react-toastify";
import ModalPop from "../../../../../components/sales/modal/modal";
import ConstantInput from "../../../../../components/sales/Input/constantInput/constantInput";
import CustomModal from "../../../../valetServices/modal";
import {BaseUrl} from "../../../../../contexts/baseUrl/baseUrl";
import Images from "../../../../../assets/images/imageData";
import './view.css'

const finiteOrNull = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
};

const formatAmount = (value) => {
    const num = finiteOrNull(value);
    return num === null ? "" : num.toFixed(2);
};

const displayNumber = (value) => {
    const num = finiteOrNull(value);
    return num === null ? "" : num;
};

const lineTotal = (item) => {
    const unitPrice = finiteOrNull(item?.unit_price);
    if (unitPrice === null) return null;

    if (item?.type === "Variable") {
        const menDays = finiteOrNull(item?.men_days);
        return menDays === null ? null : unitPrice * menDays;
    }

    if (item?.type === "On Demand" || item?.type === "Fixed") {
        const quantity = finiteOrNull(item?.quantity);
        return quantity === null ? null : quantity * unitPrice;
    }

    return null;
};

const TYPE_BY_CODE = {
    O: "On Demand",
    V: "Variable",
    F: "Fixed",
};

const normalizeLineItem = (item) => {
    const type =
        TYPE_BY_CODE[item?.variable_type] ||
        TYPE_BY_CODE[item?.meta_data?.variable_type] ||
        item?.type ||
        "";

    return {
        ...item,
        type,
        itemName: item?.services?.service_name || item?.description || "",
        men_days: item?.men_days ?? item?.meta_data?.actual_total_mandays ?? null,
        total_men_days: item?.total_men_days ?? item?.meta_data?.expected_total_mandays ?? null,
    };
};

const ApprovalServiceInvoiceLineItems = ({
    match,
    getValetItemLineInvoiceId,
    lineItemsByInvoiceId = [],
    lineItemsApprovalRejection,
    lineItemsApprovalRejectionResponse=[],
    history,
    getServiceInvoiceList,
    valetContractInvoice=[]
}) => {

    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(true);
    const [isModal, setIsModal] = useState(false);
    const [approvalStatus, setApprovalStatus] = useState(0);
    const [remarks, setRemarks] = useState("");
    const [showModalContent, setShowModalContent] = useState(true)
    const [count, setCount] = useState(0)
    const [role, setRole] = useState('')
    const reconList =
        valetContractInvoice?.resultSets?.find(
            (item) => String(item?.invoice_id) === String(match?.params?.invoice_id)
        ) || (valetContractInvoice?.resultSets?.length > 0
            ? valetContractInvoice.resultSets[0]
            : null);

    const listData = useMemo(() => {
        if (Array.isArray(lineItemsByInvoiceId) && lineItemsByInvoiceId.length > 0) {
            return lineItemsByInvoiceId.map(normalizeLineItem);
        }
        return [];
    }, [lineItemsByInvoiceId]);

    const sum = useMemo(() => {
        return listData.reduce((runningTotal, item) => {
            const amount = lineTotal(item);
            return amount === null ? runningTotal : runningTotal + amount;
        }, 0);
    }, [listData]);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setRole(localStorage.getItem("fusion-role"))
            try {
                await Promise.all([
                    getServiceInvoiceList(1, 2, null, match?.params?.invoice_id),
                    getValetItemLineInvoiceId(match?.params?.invoice_id),
                ])
            } finally {
                setIsLoading(false)
            }
        })()
    }, []);

    const setStatus = (status) => {
        setIsModal(true)
        setApprovalStatus(status)
    }

    const handleSubmit = async () => {

        if(remarks === ""){
            toast.error("Remark is required");
            return false
        }
        const submitData = {remark: remarks, installment_invoice_id: match?.params?.invoice_id, action:approvalStatus};
        setShowModalContent(false)
        setIsLoading(true)
        await lineItemsApprovalRejection(submitData)
        setIsLoading(false)
        setCount(count + 1)
        setIsModal(false)
        setShowModalContent(true)
    }

    return (
        <>
            <Layout
                title={localization.lineItem}
                isLoading={isLoading}
                isGoback={true}
            >
                {count > 0 && lineItemsApprovalRejectionResponse?.response?.status !== 200 &&
                    <CustomModal msg={lineItemsApprovalRejectionResponse?.response?.message} click={count} history={history}/>}
                {count > 0 && lineItemsApprovalRejectionResponse?.response?.status === 200 &&
                    <CustomModal msg={lineItemsApprovalRejectionResponse?.response?.message} isPageLoad={true} history={history}
                                 url={`${baseUrl}/valet-approval-invoice-list`} click={count}/>}
                {reconList &&
                        <div className="panel-card card-details service-approval-view">
                            <div className="panel-heading">{localization.invoiceModule}</div>
                            <div className="panel-body">
                                <div className="details-listing">
                                    <DivLayout
                                        heading={"PI Number"}
                                        data={reconList?.invoice_number}
                                    />
                                    <DivLayout
                                        heading={"TI Number"}
                                        data={reconList?.ti_number}
                                    />
                                    <DivLayout
                                        heading={"PI Date"}
                                        data={reconList?.invoice_date}
                                    />
                                    <DivLayout
                                        heading={"TI Date"}
                                        data={reconList?.ti_date}
                                    />
                                    <DivLayout
                                        heading={"Business Name"}
                                        data={reconList?.business_name}
                                    />
                                    <DivLayout
                                        heading={"Client Name"}
                                        data={reconList?.client_name}
                                    />
                                    <DivLayout
                                        heading={"Site Number"}
                                        data={reconList?.site_number}
                                    />
                                    <DivLayout
                                        heading={"Contract Live Date"}
                                        data={reconList?.contract_live_date}
                                    />
                                    <DivLayout
                                        heading={"Type"}
                                        data={
                                            reconList?.billing_type === 1
                                                ? "Prepaid"
                                                : reconList?.billing_type
                                                    ? "Postpaid"
                                                    : ""
                                        }
                                    />
                                    <DivLayout
                                        heading={"Status"}
                                        data={reconList?.installment_status}
                                    />
                                    <DivLayout
                                        heading={"Approved By"}
                                        data={reconList?.installment_approved_by}
                                    />
                                </div>
                            </div>
                        </div>
                }
                {!isLoading &&
                        <div className="panel-card card-details service-approval-view">
                            <div className="panel-heading">{localization.lineItem}</div>
                            <div className="panel-body">
                                {listData.length > 0 ? (
                                <>
                                <div className="line-item-scroll">
                                    <table className="table line-item-table">
                                        <thead>
                                        <tr>
                                            <th className="item-col">Item</th>
                                            <th>Type</th>
                                            <th className="num-col">Quantity</th>
                                            <th className="num-col">Unit Price</th>
                                            <th className="num-col">Actual Men Days</th>
                                            <th className="num-col">Total Men Days</th>
                                            <th className="num-col">Total Price</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {listData.map((val, i) => {
                                            const total = lineTotal(val);
                                            if (!["On Demand", "Variable", "Fixed"].includes(val?.type)) return null;
                                            return (
                                                <tr key={val?.item_id || val?.id || `${val?.type}-${i}`}>
                                                    <td className="item-col">
                                                        {val?.itemName}
                                                        {val?.type === "Variable" && finiteOrNull(val?.role_present_days) !== null && (
                                                            <>
                                                                <br />
                                                                <strong>Present Days: {val.role_present_days}</strong>
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>{val?.type}</td>
                                                    <td className="num-col">{displayNumber(val?.quantity)}</td>
                                                    <td className="num-col">{formatAmount(val?.unit_price)}</td>
                                                    <td className="num-col">{displayNumber(val?.men_days)}</td>
                                                    <td className="num-col">{displayNumber(val?.total_men_days)}</td>
                                                    <td className="num-col">{formatAmount(total)}</td>
                                                </tr>
                                            );
                                        })}
                                        <tr className="sum-row">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className="num-col">Sum</td>
                                            <td className="num-col">{Number.isFinite(sum) ? sum.toFixed(2) : "0.00"}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {parseInt(role) === 16 &&
                                    <>
                                        <div className="approval-actions">
                                            <Button type="button" className="btn-approve" onClick={() => setStatus(2)}>Approve</Button>
                                            <Button type="button" className="btn-reject" onClick={() => setStatus(3)}>Reject</Button>
                                        </div>

                                        {showModalContent &&
                                            <ModalPop
                                                title={localization.remark}
                                                show={isModal}
                                                handleModalHide={() => setIsModal(false)}
                                                isLoading={isLoading}
                                            >
                                                <ConstantInput
                                                    label={localization.remark}
                                                    value={""}
                                                    type="text"
                                                    handleChange={(val) =>
                                                        setRemarks(val)
                                                    }
                                                />
                                                <Button type="button" className="btn btn-primary" onClick={handleSubmit}>Submit</Button>
                                            </ModalPop>
                                        }
                                    </>
                                }
                                </>
                                ) : (
                                    <img src={Images?.NoData} alt="" width="100%" />
                                )}
                            </div>
                        </div>
                }

            </Layout>
        </>
    )
}

export default ApprovalServiceInvoiceLineItems